export default __webpack_public_path__ + "static/media/2023_September_See.d5a97808.webp";